import { Ref } from 'react'

import { BaseInput, BaseInputProps } from '../BaseInput'

export interface TextInputProps extends BaseInputProps {
  ref?: Ref<HTMLInputElement>
}

export const TextInput = ({ ref, ...props }: TextInputProps) => {
  return <BaseInput type="text" ref={ref} {...props} />
}
